import * as yup from 'yup';

export const updateUserSchema = yup.object().shape({
    name: yup.string().required('Name is required'),
    email: yup.string().email('Invalid email').required('Email is required'),
    phone_number: yup
        .string()
        .notRequired()
        .test('phone-format', 'Phone number must be 10 digits', (value) => {
            return !value || /^\d{10}$/.test(value);
        }),
}); 